import { FormLabel, makeStyles, TextField } from '@material-ui/core';
import styles from './CustomTextField.module.scss';
import React from 'react';
import clsx from 'clsx';

const CustomTextField = ({
	value,
	name,
	onChange,
	error,
	errorMessage,
	formLabel,
	type,
	inputProps,
	children,
	select,
	SelectProps,
	menulistprops,
	autoComplete,
	placeholder,
	required,
	style,
	multiline,
	charLimit,
	charLeft,
	readOnly,
	width,
	padding,
}) => {
	const useStyles = makeStyles((theme) => ({
		textField: {
			boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			height: '44px',
			padding: '0px',
			width: '100%',
			'&.MuiInputBase-input:invalid': {
				boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			},
		},
		multilineField: {
			boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			padding: '0px',
			width: '100%',
			'&.MuiInputBase-input:invalid': {
				boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			},
			'& p': {
				textAlign: 'right !important',
			},
			'& textarea': {
				textIndent: 10,
			},
		},
		inputLabel: {
			color: 'var(--text-mid-emphasis)',
			fontSize: 'var(--text-size-small)',
			marginBottom: '10px',
			marginLeft: '5px',
		},
		calendarIcon: {
			'&::-webkit-calendar-picker-indicator': {
				filter: 'invert(48%) sepia(98%) saturate(3020%) hue-rotate(204deg) brightness(105%) contrast(99%)',
				cursor: 'pointer',
				marginRight: '10px',
			},
		},
	}));
	const classes = useStyles();

	return (
		<div
			className={styles.textFieldWrapper}
			style={{ width: width, padding: padding }}
		>
			<FormLabel className={classes.inputLabel}>
				{formLabel} {formLabel && required && '*'}
			</FormLabel>
			{multiline === true ? (
				<>
					<TextField
						// label={field.formLabel}
						value={value}
						name={name}
						type={type}
						className={classes.multilineField}
						multiline={true}
						rows={5}
						fullWidth
						variant='standard'
						InputLabelProps={{
							shrink: true,
							disableUnderline: true,
						}}
						inputProps={{
							maxLength: charLimit,
						}}
						InputProps={{
							autoComplete: autoComplete,
							placeholder: placeholder,
							disableUnderline: true,
							readOnly: readOnly ? true : false,
						}}
						onChange={onChange}
						required={required}
						error={error}
						helperText={charLeft + '/' + charLimit}
					>
						{children}
					</TextField>
					<span
						className={styles.formHelper_error}
						style={
							error === true
								? {
										display: 'block',
								  }
								: {
										display: 'none',
								  }
						}
					>
						{errorMessage}
					</span>
				</>
			) : (
				<>
					<TextField
						// label={field.formLabel}
						value={value}
						name={name}
						type={type}
						className={`${styles.textField}`}
						fullWidth
						variant='standard'
						InputLabelProps={{
							shrink: true,
							disableUnderline: true,
						}}
						inputProps={{
							...inputProps,
							className: clsx(
								classes.textField,
								classes.calendarIcon,
								select === true ? styles.selectInput : null
							),
						}}
						InputProps={{
							disableUnderline: true,
							autoComplete: autoComplete,
							placeholder: placeholder,
							readOnly: readOnly ? true : false,
						}}
						onChange={onChange}
						// error={errorMessage}
						select={select}
						SelectProps={SelectProps}
						menulistprops={menulistprops}
						required={required}
						style={style}
						error={error}
					>
						{children}
					</TextField>
					<span
						className={styles.formHelper_error}
						style={
							error === true
								? {
										display: 'block',
								  }
								: {
										display: 'none',
								  }
						}
					>
						{errorMessage}
					</span>
				</>
			)}
		</div>
	);
};

export default CustomTextField;
